import { createNamespace } from '../utils';
import Button from '../button';

var _createNamespace = createNamespace('error'),
    createComponent = _createNamespace[0],
    bem = _createNamespace[1];

export default createComponent({
  props: {
    figure: {
      type: [Number, String],
      default: 1
    },
    title: String,
    tip: String,
    button: String
  },
  methods: {
    genFigure: function genFigure() {
      if (typeof this.figure === 'number') {
        switch (this.figure) {
          case 1:
            return 'http://mui.ucmed.cn/images/figure/busy.png';

          case 2:
            return 'http://mui.ucmed.cn/images/figure/404.png';

          case 3:
            return 'http://mui.ucmed.cn/images/figure/503.png';
        }
      } else {
        return this.figure;
      }
    }
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var slots = this.slots,
        figure = this.figure,
        title = this.title,
        tip = this.tip,
        button = this.button;
    return h("div", {
      "class": bem()
    }, [slots('figure') || figure && h("img", {
      "class": bem('figure'),
      "attrs": {
        "src": this.genFigure()
      }
    }), title && h("p", {
      "class": bem('title')
    }, [" ", title, " "]), tip && h("p", {
      "class": bem('tip')
    }, [" ", tip, " "]), button && h(Button, {
      "attrs": {
        "type": "primary",
        "plain": true,
        "block": true
      },
      "on": {
        "click": function click() {
          _this.$emit('clickButton');
        }
      }
    }, [button]), this.slots('default')]);
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant-green/es/error/index.js
// module id = null
// module chunks = 